module.exports = __webpack_public_path__ + "2c25096a71f1aa887b4554472fef3c08.svg";